export function filterClinics(clinics, query) {
  const q = query.trim().toLowerCase();
  if (!q) return clinics;

  return clinics.filter((c) => {
    const hay = [
      c.id,
      c.clinic_name,
      c.address,
      c.phone,
      c.clinic_agent_name,
      c.preferred_timezone,
      c.clinic_info,
      c.welcome_message,
      c.agent_questions ? JSON.stringify(c.agent_questions) : "",
      c.unifi_scraping_enabled ? "unifi enabled" : "unifi disabled",
      c.unifi_console_id,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    return hay.includes(q);
  });
}
